import { dashboardService, franquiciaService } from "@/_services";
import {
  NOTIFICATIONS_CACHE_TTL,
  readNotificationsCache,
  writeNotificationsCache,
  clearNotificationsCache,
} from "@/util/notificationsCache";

function notificationsContext(rootState) {
  const user = rootState.user.session.user;
  if (!user) return null;
  const franquicia = franquiciaService.getLocalFranquicia();
  const userId = user._id || user.id || user.user;
  const franquiciaId = franquicia && franquicia._id;
  return userId && franquiciaId ? JSON.stringify([userId, franquiciaId]) : null;
}

export const dashboard = {
  namespaced: true,
  state: {
    entity: {
      data: {},
      status: {},
    },
    file: {
      data: null,
      status: {},
      id: null,
      requestId: 0,
    },
    notifications: {
      data: [],
      status: {},
      contextKey: null,
      fetchedAt: 0,
      requestId: 0,
    },
  },
  mutations: {
    getDashboardRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getDashboardError(state, error) {
      state.entity.data = [];
      state.entity.status = {
        error,
      };
    },
    getDashboardSuccess(state, serv) {
      state.entity.data = serv;
      state.entity.status = {
        loaded: true,
      };
    },
    resetNotifications(state) {
      state.notifications = {
        data: [], status: {}, contextKey: null, fetchedAt: 0,
        requestId: state.notifications.requestId + 1,
      };
      state.file = {
        data: null, status: {}, id: null,
        requestId: state.file.requestId + 1,
      };
    },
    getNotificationsRequest(state, contextKey) {
      state.notifications.contextKey = contextKey;
      state.notifications.requestId += 1;
      state.notifications.status = {
        loading: true,
      };
    },
    getNotificationsError(state, error) {
      state.notifications.status = {
        error,
      };
    },
    getNotificationsSuccess(state, { data, contextKey, fetchedAt }) {
      state.notifications.data = data;
      state.notifications.contextKey = contextKey;
      state.notifications.fetchedAt = fetchedAt;
      state.notifications.status = {
        loaded: true,
      };
    },
    getNotificationFileRequest(state, id) {
      state.file.id = id;
      state.file.data = null;
      state.file.requestId += 1;
      state.file.status = {
        downloading: true,
      };
    },
    getNotificationFileError(state, error) {
      state.file.data = null;
      state.file.status = {
        error,
      };
    },
    getNotificationFileSuccess(state, data) {
      state.file.data = data;
      state.file.status = {
        downloaded: true,
      };
    },
  },
  actions: {
    getDashboard({ commit }, filters) {
      commit("getDashboardRequest");
      dashboardService
        .getDashboard(filters)
        .then((res) => {
          commit("getDashboardSuccess", res);
        })
        .catch((error) => {
          commit("getDashboardError", error);
        });
    },
    resetNotifications({ commit }) {
      clearNotificationsCache();
      commit("resetNotifications");
    },
    async getNotifications({ state, rootState, commit }, { force = false } = {}) {
      const contextKey = notificationsContext(rootState);
      if (!contextKey) {
        commit("resetNotifications");
        return;
      }
      if (state.notifications.contextKey !== contextKey) {
        commit("resetNotifications");
      }
      if (state.notifications.status.loading) return;

      if (!state.notifications.fetchedAt) {
        const cached = readNotificationsCache(contextKey);
        if (cached) commit("getNotificationsSuccess", cached);
      }
      const age = Date.now() - state.notifications.fetchedAt;
      if (!force && state.notifications.fetchedAt && age >= 0 && age < NOTIFICATIONS_CACHE_TTL) return;

      commit("getNotificationsRequest", contextKey);
      const requestId = state.notifications.requestId;
      const isCurrent = () => requestId === state.notifications.requestId &&
        contextKey === notificationsContext(rootState);
      try {
        const data = await dashboardService.getNotifications();
        if (!isCurrent()) return;
        const cached = { data, contextKey, fetchedAt: Date.now() };
        commit("getNotificationsSuccess", cached);
        writeNotificationsCache(cached);
      } catch (error) {
        if (isCurrent()) commit("getNotificationsError", error);
      }
    },
    async getNotificationFile({ state, rootState, commit }, id) {
      if (state.file.status.downloading || !id) return;
      const contextKey = notificationsContext(rootState);
      if (!contextKey) return;
      commit("getNotificationFileRequest", id);
      const requestId = state.file.requestId;
      const isCurrent = () => requestId === state.file.requestId &&
        contextKey === notificationsContext(rootState);
      try {
        const data = await dashboardService.getNotificationFile(id);
        if (isCurrent()) commit("getNotificationFileSuccess", data);
      } catch (error) {
        if (isCurrent()) commit("getNotificationFileError", error);
      }
    },
  },
};
